import { documentId } from 'firebase/firestore';
import { LocationRepository, LocationListOptions, LocationListResponse } from '../../domain/repositories/LocationRepository';
import { Location } from '../../domain/entities/Location';
import { ILoggerService } from '../../domain/services/LoggerService';
import { UserContext } from '../../domain/value-objects/UserContext';
import { BaseFirebaseRepository, FilterCondition } from './BaseFirebaseRepository';

export class FirebaseLocationRepository extends BaseFirebaseRepository<Location> implements LocationRepository {
  constructor(logger: ILoggerService) {
    super('locations', logger);
  }

  protected convertFirestoreToEntity(id: string, data: any): Location {
    return new Location(
      id,
      data.name,
      data.address,
      data.city,
      data.zipcode,
      data.monitored,
      data.organizationId,
      data.sensors || [],
      this.convertFirestoreDate(data.createdAt),
      this.convertFirestoreDate(data.updatedAt)
    );
  }

  protected getDefaultSortField(): string {
    return 'name';
  }

  protected mapSortField(sortBy: string): string {
    switch (sortBy) {
      case 'city':
        return 'city';
      case 'name':
      default:
        return 'name';
    }
  }

  protected applyLocationScopeFilters(locationIds: string[]): FilterCondition[] {
    return [{ field: documentId(), operator: 'in', value: locationIds }];
  }

  protected applySearchFilter(locations: Location[], search: string): Location[] {
    const searchLower = search.toLowerCase();
    return locations.filter(location =>
      location.name.toLowerCase().includes(searchLower) ||
      location.address.toLowerCase().includes(searchLower) ||
      location.city.toLowerCase().includes(searchLower)
    );
  }


  async findAll(options: LocationListOptions = {}, userContext?: UserContext): Promise<LocationListResponse> {
    const {
      organizationId,
      ...queryOptions
    } = options;

    const response = await this.executeQuery(userContext, queryOptions, [], [], organizationId);
    
    return {
      locations: response.items,
      totalCount: response.totalCount,
      totalPages: response.totalPages,
      currentPage: response.currentPage,
      pageSize: response.pageSize
    };
  }

  async countByOrganizationId(organizationId: string, userContext?: UserContext): Promise<number> {
    return this.countWithFilters(userContext, [], [], organizationId);
  }

  async countWithUserContext(userContext?: UserContext): Promise<number> {
    return this.countWithFilters(userContext);
  }
}